import React from "react";

function Header() {
  return (
    <header className="tc-header-style5">
      <div className="container">
        <div className="main-content">
          <div className="title font-palast-regular">
            <h1>
              <span className="fsz-70 color-brown1 font-palast-bold-italic">
                A perfeita união
              </span>{" "}
              entre
              <br /> modernidade, exclusividade
              <br /> e uma visão que transcende.{" "}
            </h1>
          </div>
          <h4 className="fsz-18 text-uppercase mt-30 lh-4 ltspc-4">
            <p>descubra o</p>
            <p className="fw-600">wiser legacy</p>
          </h4>
        </div>
        <div className="btm-content">
          <div className="row align-items-end justify-content-between">
            <div className="col-lg-2">
              <a
                href="#"
                className="circle-arrow wow zoomIn slow"
                data-wow-delay="0.2s"
              >
                <i className="far fa-long-arrow-down"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
